import { useMemo, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { sortCategories } from 'shared-utils'
import { type CategoryDTO } from 'ecosystem'
import { useSlideOutCategoriesDesktop } from './SlideOutCategoriesDesktopContext'
import { NavBlock } from './NavBlock'
import { Preview, type PreviewProps } from './Preview'

export const Nav = () => {
  const { currentTopCategory } = useSlideOutCategoriesDesktop()

  const [selectedNestedCategory, setSelectedNestedCategory] = useState<CategoryDTO | null>(null)

  const preview = useMemo<PreviewProps>(() => {
    return {
      imgUrl: selectedNestedCategory?.imgUrl || currentTopCategory?.imgUrl
    }
  }, [currentTopCategory?.imgUrl, selectedNestedCategory?.imgUrl])

  const menuCategories = useMemo(
    () => sortCategories(currentTopCategory?.subCategories || []),
    [currentTopCategory?.subCategories]
  )

  return (
    <>
      <Box w="70%">
        <NavBlock
          categories={menuCategories}
          level={1}
          onSelectNestedCategory={setSelectedNestedCategory}
          parentCategory={currentTopCategory}
        />
      </Box>

      <Box w="30%">
        <Preview {...preview} />
      </Box>
    </>
  )
}
